import imagesHostname from '@spa/lib/configs/imagesHostname';
import publicBaseUrl from '@spa/lib/configs/publicBaseUrl';

const OG_IMAGE_WIDTH = 1200;
const DEFAULT_QUALITY = 75;

const buildOptimizedImageUrl = (src: string, width: number = OG_IMAGE_WIDTH): string => {
  let result: string = '';

  if (src) {
    const path = `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${DEFAULT_QUALITY}`;
    result = imagesHostname !== null ? `${imagesHostname}${path}` : `${publicBaseUrl}${path}`;
  }

  return result;
};

export default buildOptimizedImageUrl;
